/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ApplicationStatusDto
 */
export interface ApplicationStatusDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationStatusDto
     */
    SceneID?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationStatusDto
     */
    Status?: number;
}
/**
 * 
 * @export
 * @interface CaseAgentNumber
 */
export interface CaseAgentNumber {
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumber
     */
    AgentOfRecordNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumber
     */
    CaseID?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumber
     */
    CaseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumber
     */
    ServicingAgentNumber?: string;
}
/**
 * 
 * @export
 * @interface CaseAgentNumberDto
 */
export interface CaseAgentNumberDto {
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumberDto
     */
    agentOfRecordNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumberDto
     */
    caseID?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumberDto
     */
    caseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAgentNumberDto
     */
    servicingAgentNumber?: string;
}
/**
 * 
 * @export
 * @interface ESignatureDraft
 */
export interface ESignatureDraft {
    /**
     * 
     * @type {number}
     * @memberof ESignatureDraft
     */
    ClaimInformationId?: number;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDraft
     */
    ClaimPolicyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDraft
     */
    ClaimType?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDraft
     */
    ESignatureGuid?: string;
    /**
     * 
     * @type {ESignatureType}
     * @memberof ESignatureDraft
     */
    ESignatureType?: ESignatureType;
    /**
     * 
     * @type {number}
     * @memberof ESignatureDraft
     */
    Id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ESignatureDraft
     */
    IsLocked?: boolean;
    /**
     * 
     * @type {Array<ESignatureSection>}
     * @memberof ESignatureDraft
     */
    Sections?: Array<ESignatureSection>;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDraft
     */
    SignatureAppliedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDraft
     */
    SignatureAppliedName?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDraft
     */
    UrlRedirectBack?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDraft
     */
    UrlRedirectSuccess?: string;
    /**
     * 
     * @type {number}
     * @memberof ESignatureDraft
     */
    UserAccountId?: number;
}
/**
 * 
 * @export
 * @interface ESignatureDto
 */
export interface ESignatureDto {
    /**
     * 
     * @type {number}
     * @memberof ESignatureDto
     */
    claimInformationId?: number;
    /**
     * 
     * @type {ESignatureDraft}
     * @memberof ESignatureDto
     */
    esignature?: ESignatureDraft;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDto
     */
    esignatureTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDto
     */
    esignatureTimestampUTC?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureDto
     */
    esignatureTimestampWithTz?: string;
    /**
     * 
     * @type {number}
     * @memberof ESignatureDto
     */
    esignatureTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof ESignatureDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ESignatureDto
     */
    userAccountId?: number;
}
/**
 * 
 * @export
 * @interface ESignatureQuestion
 */
export interface ESignatureQuestion {
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    DisplayLabel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ESignatureQuestion
     */
    IsInvisible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ESignatureQuestion
     */
    IsSectionBreakRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    Label?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    Name?: string;
    /**
     * 
     * @type {number}
     * @memberof ESignatureQuestion
     */
    Order?: number;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    Value?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ESignatureQuestion
     */
    dependsOn?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ESignatureQuestion
     */
    disable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    eformQuestionTypeCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    eformTypeCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    errorText?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    infoText?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    mappedColumnName?: string;
    /**
     * 
     * @type {number}
     * @memberof ESignatureQuestion
     */
    maxLength?: number;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    maxValue?: string;
    /**
     * 
     * @type {number}
     * @memberof ESignatureQuestion
     */
    minLength?: number;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    minValue?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ESignatureQuestion
     */
    required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    rows?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    tooltip?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    validationRegex?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    valueMask?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    valuePattern?: string;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    valuePlaceHolder?: string;
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ESignatureQuestion
     */
    valueSelectOptions?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ESignatureQuestion
     */
    weight?: string;
}
/**
 * 
 * @export
 * @interface ESignatureSection
 */
export interface ESignatureSection {
    /**
     * 
     * @type {string}
     * @memberof ESignatureSection
     */
    Name?: string;
    /**
     * 
     * @type {number}
     * @memberof ESignatureSection
     */
    NumberOfColumns?: number;
    /**
     * 
     * @type {number}
     * @memberof ESignatureSection
     */
    Order?: number;
    /**
     * 
     * @type {Array<ESignatureQuestion>}
     * @memberof ESignatureSection
     */
    SectionDetails?: Array<ESignatureQuestion>;
    /**
     * 
     * @type {string}
     * @memberof ESignatureSection
     */
    SubLabel?: string;
    /**
     * 
     * @type {Array<ESignatureSection>}
     * @memberof ESignatureSection
     */
    SubSection?: Array<ESignatureSection>;
    /**
     * 
     * @type {string}
     * @memberof ESignatureSection
     */
    Value?: string;
}
/**
 * 
 * @export
 * @interface ESignatureType
 */
export interface ESignatureType {
    /**
     * 
     * @type {string}
     * @memberof ESignatureType
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ESignatureType
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ESignatureType
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface GrpERCase
 */
export interface GrpERCase {
    /**
     * 
     * @type {string}
     * @memberof GrpERCase
     */
    CaseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GrpERCase
     */
    Descript?: string;
    /**
     * 
     * @type {string}
     * @memberof GrpERCase
     */
    GroupID?: string;
    /**
     * 
     * @type {string}
     * @memberof GrpERCase
     */
    SICCode?: string;
}
/**
 * 
 * @export
 * @interface GrpERCases
 */
export interface GrpERCases {
    /**
     * 
     * @type {string}
     * @memberof GrpERCases
     */
    CaseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GrpERCases
     */
    GroupID?: string;
    /**
     * 
     * @type {string}
     * @memberof GrpERCases
     */
    Name?: string;
}
/**
 * 
 * @export
 * @interface LifeDetail
 */
export interface LifeDetail {
    /**
     * 
     * @type {string}
     * @memberof LifeDetail
     */
    AccountName?: string;
    /**
     * 
     * @type {string}
     * @memberof LifeDetail
     */
    AccountNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof LifeDetail
     */
    EmployerID?: number;
    /**
     * 
     * @type {string}
     * @memberof LifeDetail
     */
    EmployerName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LifeDetail
     */
    WrittenToL70?: boolean;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Link
     */
    templated?: boolean;
}
/**
 * 
 * @export
 * @interface ModelAndView
 */
export interface ModelAndView {
    /**
     * 
     * @type {boolean}
     * @memberof ModelAndView
     */
    empty?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ModelAndView
     */
    model?: object;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ModelAndView
     */
    modelMap?: { [key: string]: object; };
    /**
     * 
     * @type {boolean}
     * @memberof ModelAndView
     */
    reference?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelAndView
     */
    status?: ModelAndViewStatusEnum;
    /**
     * 
     * @type {View}
     * @memberof ModelAndView
     */
    view?: View;
    /**
     * 
     * @type {string}
     * @memberof ModelAndView
     */
    viewName?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ModelAndViewStatusEnum {
    _100Continue = '100 CONTINUE',
    _101SwitchingProtocols = '101 SWITCHING_PROTOCOLS',
    _102Processing = '102 PROCESSING',
    _103Checkpoint = '103 CHECKPOINT',
    _200Ok = '200 OK',
    _201Created = '201 CREATED',
    _202Accepted = '202 ACCEPTED',
    _203NonAuthoritativeInformation = '203 NON_AUTHORITATIVE_INFORMATION',
    _204NoContent = '204 NO_CONTENT',
    _205ResetContent = '205 RESET_CONTENT',
    _206PartialContent = '206 PARTIAL_CONTENT',
    _207MultiStatus = '207 MULTI_STATUS',
    _208AlreadyReported = '208 ALREADY_REPORTED',
    _226ImUsed = '226 IM_USED',
    _300MultipleChoices = '300 MULTIPLE_CHOICES',
    _301MovedPermanently = '301 MOVED_PERMANENTLY',
    _302Found = '302 FOUND',
    _302MovedTemporarily = '302 MOVED_TEMPORARILY',
    _303SeeOther = '303 SEE_OTHER',
    _304NotModified = '304 NOT_MODIFIED',
    _305UseProxy = '305 USE_PROXY',
    _307TemporaryRedirect = '307 TEMPORARY_REDIRECT',
    _308PermanentRedirect = '308 PERMANENT_REDIRECT',
    _400BadRequest = '400 BAD_REQUEST',
    _401Unauthorized = '401 UNAUTHORIZED',
    _402PaymentRequired = '402 PAYMENT_REQUIRED',
    _403Forbidden = '403 FORBIDDEN',
    _404NotFound = '404 NOT_FOUND',
    _405MethodNotAllowed = '405 METHOD_NOT_ALLOWED',
    _406NotAcceptable = '406 NOT_ACCEPTABLE',
    _407ProxyAuthenticationRequired = '407 PROXY_AUTHENTICATION_REQUIRED',
    _408RequestTimeout = '408 REQUEST_TIMEOUT',
    _409Conflict = '409 CONFLICT',
    _410Gone = '410 GONE',
    _411LengthRequired = '411 LENGTH_REQUIRED',
    _412PreconditionFailed = '412 PRECONDITION_FAILED',
    _413PayloadTooLarge = '413 PAYLOAD_TOO_LARGE',
    _413RequestEntityTooLarge = '413 REQUEST_ENTITY_TOO_LARGE',
    _414UriTooLong = '414 URI_TOO_LONG',
    _414RequestUriTooLong = '414 REQUEST_URI_TOO_LONG',
    _415UnsupportedMediaType = '415 UNSUPPORTED_MEDIA_TYPE',
    _416RequestedRangeNotSatisfiable = '416 REQUESTED_RANGE_NOT_SATISFIABLE',
    _417ExpectationFailed = '417 EXPECTATION_FAILED',
    _418IAmATeapot = '418 I_AM_A_TEAPOT',
    _419InsufficientSpaceOnResource = '419 INSUFFICIENT_SPACE_ON_RESOURCE',
    _420MethodFailure = '420 METHOD_FAILURE',
    _421DestinationLocked = '421 DESTINATION_LOCKED',
    _422UnprocessableEntity = '422 UNPROCESSABLE_ENTITY',
    _423Locked = '423 LOCKED',
    _424FailedDependency = '424 FAILED_DEPENDENCY',
    _425TooEarly = '425 TOO_EARLY',
    _426UpgradeRequired = '426 UPGRADE_REQUIRED',
    _428PreconditionRequired = '428 PRECONDITION_REQUIRED',
    _429TooManyRequests = '429 TOO_MANY_REQUESTS',
    _431RequestHeaderFieldsTooLarge = '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
    _451UnavailableForLegalReasons = '451 UNAVAILABLE_FOR_LEGAL_REASONS',
    _500InternalServerError = '500 INTERNAL_SERVER_ERROR',
    _501NotImplemented = '501 NOT_IMPLEMENTED',
    _502BadGateway = '502 BAD_GATEWAY',
    _503ServiceUnavailable = '503 SERVICE_UNAVAILABLE',
    _504GatewayTimeout = '504 GATEWAY_TIMEOUT',
    _505HttpVersionNotSupported = '505 HTTP_VERSION_NOT_SUPPORTED',
    _506VariantAlsoNegotiates = '506 VARIANT_ALSO_NEGOTIATES',
    _507InsufficientStorage = '507 INSUFFICIENT_STORAGE',
    _508LoopDetected = '508 LOOP_DETECTED',
    _509BandwidthLimitExceeded = '509 BANDWIDTH_LIMIT_EXCEEDED',
    _510NotExtended = '510 NOT_EXTENDED',
    _511NetworkAuthenticationRequired = '511 NETWORK_AUTHENTICATION_REQUIRED'
}

/**
 * 
 * @export
 * @interface OnlineForm
 */
export interface OnlineForm {
    /**
     * 
     * @type {string}
     * @memberof OnlineForm
     */
    binaryValue?: string;
    /**
     * 
     * @type {string}
     * @memberof OnlineForm
     */
    corporateViewable?: string;
    /**
     * 
     * @type {string}
     * @memberof OnlineForm
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof OnlineForm
     */
    formKey?: string;
    /**
     * 
     * @type {string}
     * @memberof OnlineForm
     */
    formNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof OnlineForm
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OnlineForm
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OnlineForm
     */
    sortOrder?: number;
}
/**
 * 
 * @export
 * @interface ResponseEntity
 */
export interface ResponseEntity {
    /**
     * 
     * @type {object}
     * @memberof ResponseEntity
     */
    body?: object;
    /**
     * 
     * @type {string}
     * @memberof ResponseEntity
     */
    statusCode?: ResponseEntityStatusCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof ResponseEntity
     */
    statusCodeValue?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ResponseEntityStatusCodeEnum {
    _100Continue = '100 CONTINUE',
    _101SwitchingProtocols = '101 SWITCHING_PROTOCOLS',
    _102Processing = '102 PROCESSING',
    _103Checkpoint = '103 CHECKPOINT',
    _200Ok = '200 OK',
    _201Created = '201 CREATED',
    _202Accepted = '202 ACCEPTED',
    _203NonAuthoritativeInformation = '203 NON_AUTHORITATIVE_INFORMATION',
    _204NoContent = '204 NO_CONTENT',
    _205ResetContent = '205 RESET_CONTENT',
    _206PartialContent = '206 PARTIAL_CONTENT',
    _207MultiStatus = '207 MULTI_STATUS',
    _208AlreadyReported = '208 ALREADY_REPORTED',
    _226ImUsed = '226 IM_USED',
    _300MultipleChoices = '300 MULTIPLE_CHOICES',
    _301MovedPermanently = '301 MOVED_PERMANENTLY',
    _302Found = '302 FOUND',
    _302MovedTemporarily = '302 MOVED_TEMPORARILY',
    _303SeeOther = '303 SEE_OTHER',
    _304NotModified = '304 NOT_MODIFIED',
    _305UseProxy = '305 USE_PROXY',
    _307TemporaryRedirect = '307 TEMPORARY_REDIRECT',
    _308PermanentRedirect = '308 PERMANENT_REDIRECT',
    _400BadRequest = '400 BAD_REQUEST',
    _401Unauthorized = '401 UNAUTHORIZED',
    _402PaymentRequired = '402 PAYMENT_REQUIRED',
    _403Forbidden = '403 FORBIDDEN',
    _404NotFound = '404 NOT_FOUND',
    _405MethodNotAllowed = '405 METHOD_NOT_ALLOWED',
    _406NotAcceptable = '406 NOT_ACCEPTABLE',
    _407ProxyAuthenticationRequired = '407 PROXY_AUTHENTICATION_REQUIRED',
    _408RequestTimeout = '408 REQUEST_TIMEOUT',
    _409Conflict = '409 CONFLICT',
    _410Gone = '410 GONE',
    _411LengthRequired = '411 LENGTH_REQUIRED',
    _412PreconditionFailed = '412 PRECONDITION_FAILED',
    _413PayloadTooLarge = '413 PAYLOAD_TOO_LARGE',
    _413RequestEntityTooLarge = '413 REQUEST_ENTITY_TOO_LARGE',
    _414UriTooLong = '414 URI_TOO_LONG',
    _414RequestUriTooLong = '414 REQUEST_URI_TOO_LONG',
    _415UnsupportedMediaType = '415 UNSUPPORTED_MEDIA_TYPE',
    _416RequestedRangeNotSatisfiable = '416 REQUESTED_RANGE_NOT_SATISFIABLE',
    _417ExpectationFailed = '417 EXPECTATION_FAILED',
    _418IAmATeapot = '418 I_AM_A_TEAPOT',
    _419InsufficientSpaceOnResource = '419 INSUFFICIENT_SPACE_ON_RESOURCE',
    _420MethodFailure = '420 METHOD_FAILURE',
    _421DestinationLocked = '421 DESTINATION_LOCKED',
    _422UnprocessableEntity = '422 UNPROCESSABLE_ENTITY',
    _423Locked = '423 LOCKED',
    _424FailedDependency = '424 FAILED_DEPENDENCY',
    _425TooEarly = '425 TOO_EARLY',
    _426UpgradeRequired = '426 UPGRADE_REQUIRED',
    _428PreconditionRequired = '428 PRECONDITION_REQUIRED',
    _429TooManyRequests = '429 TOO_MANY_REQUESTS',
    _431RequestHeaderFieldsTooLarge = '431 REQUEST_HEADER_FIELDS_TOO_LARGE',
    _451UnavailableForLegalReasons = '451 UNAVAILABLE_FOR_LEGAL_REASONS',
    _500InternalServerError = '500 INTERNAL_SERVER_ERROR',
    _501NotImplemented = '501 NOT_IMPLEMENTED',
    _502BadGateway = '502 BAD_GATEWAY',
    _503ServiceUnavailable = '503 SERVICE_UNAVAILABLE',
    _504GatewayTimeout = '504 GATEWAY_TIMEOUT',
    _505HttpVersionNotSupported = '505 HTTP_VERSION_NOT_SUPPORTED',
    _506VariantAlsoNegotiates = '506 VARIANT_ALSO_NEGOTIATES',
    _507InsufficientStorage = '507 INSUFFICIENT_STORAGE',
    _508LoopDetected = '508 LOOP_DETECTED',
    _509BandwidthLimitExceeded = '509 BANDWIDTH_LIMIT_EXCEEDED',
    _510NotExtended = '510 NOT_EXTENDED',
    _511NetworkAuthenticationRequired = '511 NETWORK_AUTHENTICATION_REQUIRED'
}

/**
 * 
 * @export
 * @interface Timestamp
 */
export interface Timestamp {
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    date?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    day?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    hours?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    minutes?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    nanos?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    seconds?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    time?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    timezoneOffset?: number;
    /**
     * 
     * @type {number}
     * @memberof Timestamp
     */
    year?: number;
}
/**
 * 
 * @export
 * @interface UserDocument
 */
export interface UserDocument {
    /**
     * 
     * @type {number}
     * @memberof UserDocument
     */
    claimId?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    claimNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDocument
     */
    claimRequirementId?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    createdBy?: string;
    /**
     * 
     * @type {Timestamp}
     * @memberof UserDocument
     */
    createdDate?: Timestamp;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    documentData?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    documentExtension?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    documentMetaJson?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    documentName?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDocument
     */
    documentSourceTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    fullPath?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDocument
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    modifiedBy?: string;
    /**
     * 
     * @type {Timestamp}
     * @memberof UserDocument
     */
    modifiedDate?: Timestamp;
    /**
     * 
     * @type {string}
     * @memberof UserDocument
     */
    policyNumber?: string;
    /**
     * 
     * @type {Timestamp}
     * @memberof UserDocument
     */
    submitDate?: Timestamp;
    /**
     * 
     * @type {number}
     * @memberof UserDocument
     */
    userAccountId?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDocument
     */
    userDocumentTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDocument
     */
    userTransactionId?: number;
}
/**
 * 
 * @export
 * @interface View
 */
export interface View {
    /**
     * 
     * @type {string}
     * @memberof View
     */
    contentType?: string;
}

/**
 * ApplicationStatusControllerApi - axios parameter creator
 * @export
 */
export const ApplicationStatusControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Application Status by sceneId
         * @param {string} sceneID sceneID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationStatusBySceneIdUsingGET: async (sceneID: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneID' is not null or undefined
            assertParamExists('getApplicationStatusBySceneIdUsingGET', 'sceneID', sceneID)
            const localVarPath = `/v1/bostools/applicationstatus/{sceneID}`
                .replace(`{${"sceneID"}}`, encodeURIComponent(String(sceneID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Application Status
         * @param {string} sceneID sceneID
         * @param {number} status status
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationStatusUsingPUT: async (sceneID: string, status: number, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneID' is not null or undefined
            assertParamExists('updateApplicationStatusUsingPUT', 'sceneID', sceneID)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateApplicationStatusUsingPUT', 'status', status)
            const localVarPath = `/v1/bostools/applicationstatus/{sceneID}`
                .replace(`{${"sceneID"}}`, encodeURIComponent(String(sceneID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationStatusControllerApi - functional programming interface
 * @export
 */
export const ApplicationStatusControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationStatusControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Application Status by sceneId
         * @param {string} sceneID sceneID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicationStatusBySceneIdUsingGET(sceneID: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicationStatusBySceneIdUsingGET(sceneID, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Application Status
         * @param {string} sceneID sceneID
         * @param {number} status status
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApplicationStatusUsingPUT(sceneID: string, status: number, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApplicationStatusUsingPUT(sceneID, status, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApplicationStatusControllerApi - factory interface
 * @export
 */
export const ApplicationStatusControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationStatusControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Application Status by sceneId
         * @param {string} sceneID sceneID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationStatusBySceneIdUsingGET(sceneID: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<ApplicationStatusDto> {
            return localVarFp.getApplicationStatusBySceneIdUsingGET(sceneID, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Application Status
         * @param {string} sceneID sceneID
         * @param {number} status status
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApplicationStatusUsingPUT(sceneID: string, status: number, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<number> {
            return localVarFp.updateApplicationStatusUsingPUT(sceneID, status, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicationStatusControllerApi - object-oriented interface
 * @export
 * @class ApplicationStatusControllerApi
 * @extends {BaseAPI}
 */
export class ApplicationStatusControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Application Status by sceneId
     * @param {string} sceneID sceneID
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationStatusControllerApi
     */
    public getApplicationStatusBySceneIdUsingGET(sceneID: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return ApplicationStatusControllerApiFp(this.configuration).getApplicationStatusBySceneIdUsingGET(sceneID, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Application Status
     * @param {string} sceneID sceneID
     * @param {number} status status
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationStatusControllerApi
     */
    public updateApplicationStatusUsingPUT(sceneID: string, status: number, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return ApplicationStatusControllerApiFp(this.configuration).updateApplicationStatusUsingPUT(sceneID, status, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BasicErrorControllerApi - axios parameter creator
 * @export
 */
export const BasicErrorControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingDELETE: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingGET: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingHEAD: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingOPTIONS: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingPATCH: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingPOST: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingPUT: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BasicErrorControllerApi - functional programming interface
 * @export
 */
export const BasicErrorControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BasicErrorControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorUsingDELETE(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorUsingDELETE(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorUsingGET(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorUsingHEAD(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorUsingHEAD(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorUsingOPTIONS(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorUsingOPTIONS(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorUsingPATCH(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorUsingPATCH(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorUsingPOST(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorUsingPOST(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorUsingPUT(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorUsingPUT(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BasicErrorControllerApi - factory interface
 * @export
 */
export const BasicErrorControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BasicErrorControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingDELETE(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.errorUsingDELETE(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingGET(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.errorUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingHEAD(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.errorUsingHEAD(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingOPTIONS(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.errorUsingOPTIONS(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingPATCH(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.errorUsingPATCH(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingPOST(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.errorUsingPOST(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorUsingPUT(options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.errorUsingPUT(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BasicErrorControllerApi - object-oriented interface
 * @export
 * @class BasicErrorControllerApi
 * @extends {BaseAPI}
 */
export class BasicErrorControllerApi extends BaseAPI {
    /**
     * 
     * @summary error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorUsingDELETE(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorUsingDELETE(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorUsingGET(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorUsingHEAD(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorUsingHEAD(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorUsingOPTIONS(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorUsingOPTIONS(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorUsingPATCH(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorUsingPATCH(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorUsingPOST(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorUsingPOST(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorUsingPUT(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorUsingPUT(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CaseAgentControllerApi - axios parameter creator
 * @export
 */
export const CaseAgentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get case agent numbers
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseAgentNumbersByCaseNumberUsingGET: async (caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('getCaseAgentNumbersByCaseNumberUsingGET', 'caseNumber', caseNumber)
            const localVarPath = `/v1/bostools/caseagentnumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseAgentControllerApi - functional programming interface
 * @export
 */
export const CaseAgentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseAgentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get case agent numbers
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseAgentNumbersByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CaseAgentNumberDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseAgentNumbersByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CaseAgentControllerApi - factory interface
 * @export
 */
export const CaseAgentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseAgentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary get case agent numbers
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseAgentNumbersByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<Array<CaseAgentNumberDto>> {
            return localVarFp.getCaseAgentNumbersByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseAgentControllerApi - object-oriented interface
 * @export
 * @class CaseAgentControllerApi
 * @extends {BaseAPI}
 */
export class CaseAgentControllerApi extends BaseAPI {
    /**
     * 
     * @summary get case agent numbers
     * @param {string} caseNumber caseNumber
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseAgentControllerApi
     */
    public getCaseAgentNumbersByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return CaseAgentControllerApiFp(this.configuration).getCaseAgentNumbersByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CaseNameControllerApi - axios parameter creator
 * @export
 */
export const CaseNameControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get case names
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseNameByCaseNumberUsingGET: async (caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('getCaseNameByCaseNumberUsingGET', 'caseNumber', caseNumber)
            const localVarPath = `/v1/bostools/casenames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update CaseName
         * @param {string} caseName caseName
         * @param {string} groupID groupID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseNameByGroupIDUsingPUT: async (caseName: string, groupID: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseName' is not null or undefined
            assertParamExists('updateCaseNameByGroupIDUsingPUT', 'caseName', caseName)
            // verify required parameter 'groupID' is not null or undefined
            assertParamExists('updateCaseNameByGroupIDUsingPUT', 'groupID', groupID)
            const localVarPath = `/v1/bostools/casenames/{groupID}`
                .replace(`{${"groupID"}}`, encodeURIComponent(String(groupID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (caseName !== undefined) {
                localVarQueryParameter['caseName'] = caseName;
            }

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseNameControllerApi - functional programming interface
 * @export
 */
export const CaseNameControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseNameControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get case names
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseNameByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GrpERCases>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseNameByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update CaseName
         * @param {string} caseName caseName
         * @param {string} groupID groupID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCaseNameByGroupIDUsingPUT(caseName: string, groupID: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCaseNameByGroupIDUsingPUT(caseName, groupID, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CaseNameControllerApi - factory interface
 * @export
 */
export const CaseNameControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseNameControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary get case names
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseNameByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<Array<GrpERCases>> {
            return localVarFp.getCaseNameByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update CaseName
         * @param {string} caseName caseName
         * @param {string} groupID groupID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseNameByGroupIDUsingPUT(caseName: string, groupID: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<number> {
            return localVarFp.updateCaseNameByGroupIDUsingPUT(caseName, groupID, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseNameControllerApi - object-oriented interface
 * @export
 * @class CaseNameControllerApi
 * @extends {BaseAPI}
 */
export class CaseNameControllerApi extends BaseAPI {
    /**
     * 
     * @summary get case names
     * @param {string} caseNumber caseNumber
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNameControllerApi
     */
    public getCaseNameByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return CaseNameControllerApiFp(this.configuration).getCaseNameByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update CaseName
     * @param {string} caseName caseName
     * @param {string} groupID groupID
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNameControllerApi
     */
    public updateCaseNameByGroupIDUsingPUT(caseName: string, groupID: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return CaseNameControllerApiFp(this.configuration).updateCaseNameByGroupIDUsingPUT(caseName, groupID, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ESignatureControllerApi - axios parameter creator
 * @export
 */
export const ESignatureControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ESignature Detail
         * @param {string} eSignGUID eSignGUID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getESignatureDetailUsingGET: async (eSignGUID: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eSignGUID' is not null or undefined
            assertParamExists('getESignatureDetailUsingGET', 'eSignGUID', eSignGUID)
            const localVarPath = `/v1/eSignDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (eSignGUID !== undefined) {
                localVarQueryParameter['eSignGUID'] = eSignGUID;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getESignatureDetail
         * @param {string} encryptionKey encryptionKey
         * @param {string} encryptedJson encryptedJson
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getESignatureDetailUsingPOST: async (encryptionKey: string, encryptedJson: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'encryptionKey' is not null or undefined
            assertParamExists('getESignatureDetailUsingPOST', 'encryptionKey', encryptionKey)
            // verify required parameter 'encryptedJson' is not null or undefined
            assertParamExists('getESignatureDetailUsingPOST', 'encryptedJson', encryptedJson)
            const localVarPath = `/v1/decryptesign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (encryptionKey !== undefined && encryptionKey !== null) {
                localVarHeaderParameter['encryptionKey'] = String(encryptionKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encryptedJson, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ESignatureControllerApi - functional programming interface
 * @export
 */
export const ESignatureControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ESignatureControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ESignature Detail
         * @param {string} eSignGUID eSignGUID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getESignatureDetailUsingGET(eSignGUID: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ESignatureDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getESignatureDetailUsingGET(eSignGUID, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getESignatureDetail
         * @param {string} encryptionKey encryptionKey
         * @param {string} encryptedJson encryptedJson
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getESignatureDetailUsingPOST(encryptionKey: string, encryptedJson: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getESignatureDetailUsingPOST(encryptionKey, encryptedJson, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ESignatureControllerApi - factory interface
 * @export
 */
export const ESignatureControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ESignatureControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary ESignature Detail
         * @param {string} eSignGUID eSignGUID
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getESignatureDetailUsingGET(eSignGUID: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<ESignatureDto> {
            return localVarFp.getESignatureDetailUsingGET(eSignGUID, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getESignatureDetail
         * @param {string} encryptionKey encryptionKey
         * @param {string} encryptedJson encryptedJson
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getESignatureDetailUsingPOST(encryptionKey: string, encryptedJson: string, options?: any): AxiosPromise<string> {
            return localVarFp.getESignatureDetailUsingPOST(encryptionKey, encryptedJson, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ESignatureControllerApi - object-oriented interface
 * @export
 * @class ESignatureControllerApi
 * @extends {BaseAPI}
 */
export class ESignatureControllerApi extends BaseAPI {
    /**
     * 
     * @summary ESignature Detail
     * @param {string} eSignGUID eSignGUID
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ESignatureControllerApi
     */
    public getESignatureDetailUsingGET(eSignGUID: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return ESignatureControllerApiFp(this.configuration).getESignatureDetailUsingGET(eSignGUID, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getESignatureDetail
     * @param {string} encryptionKey encryptionKey
     * @param {string} encryptedJson encryptedJson
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ESignatureControllerApi
     */
    public getESignatureDetailUsingPOST(encryptionKey: string, encryptedJson: string, options?: any) {
        return ESignatureControllerApiFp(this.configuration).getESignatureDetailUsingPOST(encryptionKey, encryptedJson, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeatureControllerApi - axios parameter creator
 * @export
 */
export const FeatureControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Flag is maintenance mode is on or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceModeFlagUsingGET: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/maintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Feature Active Flag by AccountNumber
         * @param {string} featureName featureName
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isFeatureActiveUsingGET: async (featureName: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists('isFeatureActiveUsingGET', 'featureName', featureName)
            const localVarPath = `/v1/feature/{featureName}`
                .replace(`{${"featureName"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureControllerApi - functional programming interface
 * @export
 */
export const FeatureControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Flag is maintenance mode is on or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaintenanceModeFlagUsingGET(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaintenanceModeFlagUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Feature Active Flag by AccountNumber
         * @param {string} featureName featureName
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isFeatureActiveUsingGET(featureName: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isFeatureActiveUsingGET(featureName, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeatureControllerApi - factory interface
 * @export
 */
export const FeatureControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Flag is maintenance mode is on or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceModeFlagUsingGET(options?: any): AxiosPromise<boolean> {
            return localVarFp.getMaintenanceModeFlagUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Feature Active Flag by AccountNumber
         * @param {string} featureName featureName
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isFeatureActiveUsingGET(featureName: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.isFeatureActiveUsingGET(featureName, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureControllerApi - object-oriented interface
 * @export
 * @class FeatureControllerApi
 * @extends {BaseAPI}
 */
export class FeatureControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Flag is maintenance mode is on or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureControllerApi
     */
    public getMaintenanceModeFlagUsingGET(options?: any) {
        return FeatureControllerApiFp(this.configuration).getMaintenanceModeFlagUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Feature Active Flag by AccountNumber
     * @param {string} featureName featureName
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureControllerApi
     */
    public isFeatureActiveUsingGET(featureName: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return FeatureControllerApiFp(this.configuration).isFeatureActiveUsingGET(featureName, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FormsApiApi - axios parameter creator
 * @export
 */
export const FormsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getFormById
         * @param {number} formId formId
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormByIdUsingGET: async (formId: number, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('getFormByIdUsingGET', 'formId', formId)
            const localVarPath = `/v1/forms/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getFormFields
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormFieldsUsingGET: async (claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/formFields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getFormsForLoggedInUser
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [policyNumber] policyNumber
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormsForLoggedInUserUsingGET: async (claims?: object, headers?: object, policyNumber?: string, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/forms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (policyNumber !== undefined) {
                localVarQueryParameter['policyNumber'] = policyNumber;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary uploadForms
         * @param {any} documentTypeId documentTypeId
         * @param {any} files files
         * @param {any} [claims] 
         * @param {any} [headers] 
         * @param {any} [policyNumber] policyNumber
         * @param {any} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFormsUsingPOST: async (documentTypeId: any, files: any, claims?: any, headers?: any, policyNumber?: any, tokenValue?: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentTypeId' is not null or undefined
            assertParamExists('uploadFormsUsingPOST', 'documentTypeId', documentTypeId)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadFormsUsingPOST', 'files', files)
            const localVarPath = `/v1/uploadForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (claims !== undefined) { 
                localVarFormParams.append('claims', new Blob([JSON.stringify(claims)], { type: "application/json", }));
            }
    
            if (documentTypeId !== undefined) { 
                localVarFormParams.append('documentTypeId', new Blob([JSON.stringify(documentTypeId)], { type: "application/json", }));
            }
    
            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
            if (headers !== undefined) { 
                localVarFormParams.append('headers', new Blob([JSON.stringify(headers)], { type: "application/json", }));
            }
    
            if (policyNumber !== undefined) { 
                localVarFormParams.append('policyNumber', new Blob([JSON.stringify(policyNumber)], { type: "application/json", }));
            }
    
            if (tokenValue !== undefined) { 
                localVarFormParams.append('tokenValue', new Blob([JSON.stringify(tokenValue)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormsApiApi - functional programming interface
 * @export
 */
export const FormsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getFormById
         * @param {number} formId formId
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormByIdUsingGET(formId: number, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormByIdUsingGET(formId, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getFormFields
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormFieldsUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormFieldsUsingGET(claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getFormsForLoggedInUser
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [policyNumber] policyNumber
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFormsForLoggedInUserUsingGET(claims?: object, headers?: object, policyNumber?: string, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<OnlineForm>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFormsForLoggedInUserUsingGET(claims, headers, policyNumber, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary uploadForms
         * @param {any} documentTypeId documentTypeId
         * @param {any} files files
         * @param {any} [claims] 
         * @param {any} [headers] 
         * @param {any} [policyNumber] policyNumber
         * @param {any} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFormsUsingPOST(documentTypeId: any, files: any, claims?: any, headers?: any, policyNumber?: any, tokenValue?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFormsUsingPOST(documentTypeId, files, claims, headers, policyNumber, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FormsApiApi - factory interface
 * @export
 */
export const FormsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormsApiApiFp(configuration)
    return {
        /**
         * 
         * @summary getFormById
         * @param {number} formId formId
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormByIdUsingGET(formId: number, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<string> {
            return localVarFp.getFormByIdUsingGET(formId, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getFormFields
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormFieldsUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.getFormFieldsUsingGET(claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getFormsForLoggedInUser
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [policyNumber] policyNumber
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFormsForLoggedInUserUsingGET(claims?: object, headers?: object, policyNumber?: string, tokenValue?: string, options?: any): AxiosPromise<{ [key: string]: Array<OnlineForm>; }> {
            return localVarFp.getFormsForLoggedInUserUsingGET(claims, headers, policyNumber, tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary uploadForms
         * @param {any} documentTypeId documentTypeId
         * @param {any} files files
         * @param {any} [claims] 
         * @param {any} [headers] 
         * @param {any} [policyNumber] policyNumber
         * @param {any} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFormsUsingPOST(documentTypeId: any, files: any, claims?: any, headers?: any, policyNumber?: any, tokenValue?: any, options?: any): AxiosPromise<UserDocument> {
            return localVarFp.uploadFormsUsingPOST(documentTypeId, files, claims, headers, policyNumber, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FormsApiApi - object-oriented interface
 * @export
 * @class FormsApiApi
 * @extends {BaseAPI}
 */
export class FormsApiApi extends BaseAPI {
    /**
     * 
     * @summary getFormById
     * @param {number} formId formId
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApiApi
     */
    public getFormByIdUsingGET(formId: number, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return FormsApiApiFp(this.configuration).getFormByIdUsingGET(formId, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getFormFields
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApiApi
     */
    public getFormFieldsUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return FormsApiApiFp(this.configuration).getFormFieldsUsingGET(claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getFormsForLoggedInUser
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [policyNumber] policyNumber
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApiApi
     */
    public getFormsForLoggedInUserUsingGET(claims?: object, headers?: object, policyNumber?: string, tokenValue?: string, options?: any) {
        return FormsApiApiFp(this.configuration).getFormsForLoggedInUserUsingGET(claims, headers, policyNumber, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary uploadForms
     * @param {any} documentTypeId documentTypeId
     * @param {any} files files
     * @param {any} [claims] 
     * @param {any} [headers] 
     * @param {any} [policyNumber] policyNumber
     * @param {any} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FormsApiApi
     */
    public uploadFormsUsingPOST(documentTypeId: any, files: any, claims?: any, headers?: any, policyNumber?: any, tokenValue?: any, options?: any) {
        return FormsApiApiFp(this.configuration).uploadFormsUsingPOST(documentTypeId, files, claims, headers, policyNumber, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GrandfatheringDataControllerApi - axios parameter creator
 * @export
 */
export const GrandfatheringDataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getGrandfatheringData
         * @param {boolean} exportToCsv ExportToCsv
         * @param {number} pageNumber PageNumber
         * @param {number} pageSize PageSize
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandfatheringDataUsingGET: async (exportToCsv: boolean, pageNumber: number, pageSize: number, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportToCsv' is not null or undefined
            assertParamExists('getGrandfatheringDataUsingGET', 'exportToCsv', exportToCsv)
            // verify required parameter 'pageNumber' is not null or undefined
            assertParamExists('getGrandfatheringDataUsingGET', 'pageNumber', pageNumber)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getGrandfatheringDataUsingGET', 'pageSize', pageSize)
            const localVarPath = `/v1/bostools/grandfatheringdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (exportToCsv !== undefined) {
                localVarQueryParameter['ExportToCsv'] = exportToCsv;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrandfatheringDataControllerApi - functional programming interface
 * @export
 */
export const GrandfatheringDataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrandfatheringDataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getGrandfatheringData
         * @param {boolean} exportToCsv ExportToCsv
         * @param {number} pageNumber PageNumber
         * @param {number} pageSize PageSize
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrandfatheringDataUsingGET(exportToCsv: boolean, pageNumber: number, pageSize: number, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrandfatheringDataUsingGET(exportToCsv, pageNumber, pageSize, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GrandfatheringDataControllerApi - factory interface
 * @export
 */
export const GrandfatheringDataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrandfatheringDataControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getGrandfatheringData
         * @param {boolean} exportToCsv ExportToCsv
         * @param {number} pageNumber PageNumber
         * @param {number} pageSize PageSize
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrandfatheringDataUsingGET(exportToCsv: boolean, pageNumber: number, pageSize: number, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<ResponseEntity> {
            return localVarFp.getGrandfatheringDataUsingGET(exportToCsv, pageNumber, pageSize, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrandfatheringDataControllerApi - object-oriented interface
 * @export
 * @class GrandfatheringDataControllerApi
 * @extends {BaseAPI}
 */
export class GrandfatheringDataControllerApi extends BaseAPI {
    /**
     * 
     * @summary getGrandfatheringData
     * @param {boolean} exportToCsv ExportToCsv
     * @param {number} pageNumber PageNumber
     * @param {number} pageSize PageSize
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrandfatheringDataControllerApi
     */
    public getGrandfatheringDataUsingGET(exportToCsv: boolean, pageNumber: number, pageSize: number, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return GrandfatheringDataControllerApiFp(this.configuration).getGrandfatheringDataUsingGET(exportToCsv, pageNumber, pageSize, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LifeControllerApi - axios parameter creator
 * @export
 */
export const LifeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update Agent UserName
         * @param {number} employerID employerID
         * @param {boolean} writtenToL70 writtenToL70
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWrittenToL70FlagCommandUsingPUT: async (employerID: number, writtenToL70: boolean, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'employerID' is not null or undefined
            assertParamExists('updateWrittenToL70FlagCommandUsingPUT', 'employerID', employerID)
            // verify required parameter 'writtenToL70' is not null or undefined
            assertParamExists('updateWrittenToL70FlagCommandUsingPUT', 'writtenToL70', writtenToL70)
            const localVarPath = `/v1/bostools/life/{employerID}`
                .replace(`{${"employerID"}}`, encodeURIComponent(String(employerID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }

            if (writtenToL70 !== undefined) {
                localVarQueryParameter['writtenToL70'] = writtenToL70;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LifeControllerApi - functional programming interface
 * @export
 */
export const LifeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LifeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update Agent UserName
         * @param {number} employerID employerID
         * @param {boolean} writtenToL70 writtenToL70
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWrittenToL70FlagCommandUsingPUT(employerID: number, writtenToL70: boolean, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWrittenToL70FlagCommandUsingPUT(employerID, writtenToL70, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LifeControllerApi - factory interface
 * @export
 */
export const LifeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LifeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Update Agent UserName
         * @param {number} employerID employerID
         * @param {boolean} writtenToL70 writtenToL70
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWrittenToL70FlagCommandUsingPUT(employerID: number, writtenToL70: boolean, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<number> {
            return localVarFp.updateWrittenToL70FlagCommandUsingPUT(employerID, writtenToL70, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LifeControllerApi - object-oriented interface
 * @export
 * @class LifeControllerApi
 * @extends {BaseAPI}
 */
export class LifeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Update Agent UserName
     * @param {number} employerID employerID
     * @param {boolean} writtenToL70 writtenToL70
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeControllerApi
     */
    public updateWrittenToL70FlagCommandUsingPUT(employerID: number, writtenToL70: boolean, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return LifeControllerApiFp(this.configuration).updateWrittenToL70FlagCommandUsingPUT(employerID, writtenToL70, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LifeDetailsControllerApi - axios parameter creator
 * @export
 */
export const LifeDetailsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get LifeDetails by AccountNumber
         * @param {string} accountNumber accountNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailsByAccountNumberUsingGET: async (accountNumber: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNumber' is not null or undefined
            assertParamExists('getLifeDetailsByAccountNumberUsingGET', 'accountNumber', accountNumber)
            const localVarPath = `/v1/bostools/life`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountNumber !== undefined) {
                localVarQueryParameter['accountNumber'] = accountNumber;
            }

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LifeDetailsControllerApi - functional programming interface
 * @export
 */
export const LifeDetailsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LifeDetailsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get LifeDetails by AccountNumber
         * @param {string} accountNumber accountNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLifeDetailsByAccountNumberUsingGET(accountNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LifeDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLifeDetailsByAccountNumberUsingGET(accountNumber, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LifeDetailsControllerApi - factory interface
 * @export
 */
export const LifeDetailsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LifeDetailsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get LifeDetails by AccountNumber
         * @param {string} accountNumber accountNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeDetailsByAccountNumberUsingGET(accountNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<Array<LifeDetail>> {
            return localVarFp.getLifeDetailsByAccountNumberUsingGET(accountNumber, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LifeDetailsControllerApi - object-oriented interface
 * @export
 * @class LifeDetailsControllerApi
 * @extends {BaseAPI}
 */
export class LifeDetailsControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get LifeDetails by AccountNumber
     * @param {string} accountNumber accountNumber
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeDetailsControllerApi
     */
    public getLifeDetailsByAccountNumberUsingGET(accountNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return LifeDetailsControllerApiFp(this.configuration).getLifeDetailsByAccountNumberUsingGET(accountNumber, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OpenApiResourceApi - axios parameter creator
 * @export
 */
export const OpenApiResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary openapiJson
         * @param {string} [apiDocsUrl] apiDocsUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiJsonUsingGET: async (apiDocsUrl?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDocsUrl, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary openapiYaml
         * @param {string} [apiDocsUrl] apiDocsUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiYamlUsingGET: async (apiDocsUrl?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-docs.yaml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDocsUrl, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpenApiResourceApi - functional programming interface
 * @export
 */
export const OpenApiResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpenApiResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary openapiJson
         * @param {string} [apiDocsUrl] apiDocsUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiJsonUsingGET(apiDocsUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiJsonUsingGET(apiDocsUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary openapiYaml
         * @param {string} [apiDocsUrl] apiDocsUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiYamlUsingGET(apiDocsUrl?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiYamlUsingGET(apiDocsUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OpenApiResourceApi - factory interface
 * @export
 */
export const OpenApiResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpenApiResourceApiFp(configuration)
    return {
        /**
         * 
         * @summary openapiJson
         * @param {string} [apiDocsUrl] apiDocsUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiJsonUsingGET(apiDocsUrl?: string, options?: any): AxiosPromise<string> {
            return localVarFp.openapiJsonUsingGET(apiDocsUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary openapiYaml
         * @param {string} [apiDocsUrl] apiDocsUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiYamlUsingGET(apiDocsUrl?: string, options?: any): AxiosPromise<string> {
            return localVarFp.openapiYamlUsingGET(apiDocsUrl, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OpenApiResourceApi - object-oriented interface
 * @export
 * @class OpenApiResourceApi
 * @extends {BaseAPI}
 */
export class OpenApiResourceApi extends BaseAPI {
    /**
     * 
     * @summary openapiJson
     * @param {string} [apiDocsUrl] apiDocsUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenApiResourceApi
     */
    public openapiJsonUsingGET(apiDocsUrl?: string, options?: any) {
        return OpenApiResourceApiFp(this.configuration).openapiJsonUsingGET(apiDocsUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary openapiYaml
     * @param {string} [apiDocsUrl] apiDocsUrl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenApiResourceApi
     */
    public openapiYamlUsingGET(apiDocsUrl?: string, options?: any) {
        return OpenApiResourceApiFp(this.configuration).openapiYamlUsingGET(apiDocsUrl, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OperationHandlerApi - axios parameter creator
 * @export
 */
export const OperationHandlerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET: async (body?: { [key: string]: string; }, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/health/**`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET1: async (body?: { [key: string]: string; }, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET2: async (body?: { [key: string]: string; }, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperationHandlerApi - functional programming interface
 * @export
 */
export const OperationHandlerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperationHandlerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleUsingGET(body?: { [key: string]: string; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleUsingGET(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleUsingGET1(body?: { [key: string]: string; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleUsingGET1(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleUsingGET2(body?: { [key: string]: string; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleUsingGET2(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OperationHandlerApi - factory interface
 * @export
 */
export const OperationHandlerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperationHandlerApiFp(configuration)
    return {
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET(body?: { [key: string]: string; }, options?: any): AxiosPromise<object> {
            return localVarFp.handleUsingGET(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET1(body?: { [key: string]: string; }, options?: any): AxiosPromise<object> {
            return localVarFp.handleUsingGET1(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET2(body?: { [key: string]: string; }, options?: any): AxiosPromise<object> {
            return localVarFp.handleUsingGET2(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperationHandlerApi - object-oriented interface
 * @export
 * @class OperationHandlerApi
 * @extends {BaseAPI}
 */
export class OperationHandlerApi extends BaseAPI {
    /**
     * 
     * @summary handle
     * @param {{ [key: string]: string; }} [body] body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationHandlerApi
     */
    public handleUsingGET(body?: { [key: string]: string; }, options?: any) {
        return OperationHandlerApiFp(this.configuration).handleUsingGET(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary handle
     * @param {{ [key: string]: string; }} [body] body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationHandlerApi
     */
    public handleUsingGET1(body?: { [key: string]: string; }, options?: any) {
        return OperationHandlerApiFp(this.configuration).handleUsingGET1(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary handle
     * @param {{ [key: string]: string; }} [body] body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationHandlerApi
     */
    public handleUsingGET2(body?: { [key: string]: string; }, options?: any) {
        return OperationHandlerApiFp(this.configuration).handleUsingGET2(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrchestratorControllerApi - axios parameter creator
 * @export
 */
export const OrchestratorControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Non-Auth Broker Portal Footer Feature Flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        landingPageFooterUsingGET: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/broker/landingPageFooter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Feature Active Flag by AccountNumber
         * @param {string} key key
         * @param {object} [claims] 
         * @param {boolean} [defaultActive] defaultActive
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orchestrateTaskUsingPOST: async (key: string, claims?: object, defaultActive?: boolean, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('orchestrateTaskUsingPOST', 'key', key)
            const localVarPath = `/v1/orchestrate/{key}/task`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (defaultActive !== undefined) {
                localVarQueryParameter['defaultActive'] = defaultActive;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrchestratorControllerApi - functional programming interface
 * @export
 */
export const OrchestratorControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrchestratorControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Non-Auth Broker Portal Footer Feature Flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async landingPageFooterUsingGET(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.landingPageFooterUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Feature Active Flag by AccountNumber
         * @param {string} key key
         * @param {object} [claims] 
         * @param {boolean} [defaultActive] defaultActive
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orchestrateTaskUsingPOST(key: string, claims?: object, defaultActive?: boolean, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orchestrateTaskUsingPOST(key, claims, defaultActive, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrchestratorControllerApi - factory interface
 * @export
 */
export const OrchestratorControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrchestratorControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Non-Auth Broker Portal Footer Feature Flag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        landingPageFooterUsingGET(options?: any): AxiosPromise<boolean> {
            return localVarFp.landingPageFooterUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Feature Active Flag by AccountNumber
         * @param {string} key key
         * @param {object} [claims] 
         * @param {boolean} [defaultActive] defaultActive
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orchestrateTaskUsingPOST(key: string, claims?: object, defaultActive?: boolean, headers?: object, tokenValue?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.orchestrateTaskUsingPOST(key, claims, defaultActive, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrchestratorControllerApi - object-oriented interface
 * @export
 * @class OrchestratorControllerApi
 * @extends {BaseAPI}
 */
export class OrchestratorControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Non-Auth Broker Portal Footer Feature Flag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrchestratorControllerApi
     */
    public landingPageFooterUsingGET(options?: any) {
        return OrchestratorControllerApiFp(this.configuration).landingPageFooterUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Feature Active Flag by AccountNumber
     * @param {string} key key
     * @param {object} [claims] 
     * @param {boolean} [defaultActive] defaultActive
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrchestratorControllerApi
     */
    public orchestrateTaskUsingPOST(key: string, claims?: object, defaultActive?: boolean, headers?: object, tokenValue?: string, options?: any) {
        return OrchestratorControllerApiFp(this.configuration).orchestrateTaskUsingPOST(key, claims, defaultActive, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionPreferenceControllerApi - axios parameter creator
 * @export
 */
export const SessionPreferenceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getSessionPreference
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionPreferenceUsingGET: async (claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/sessionPreference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionPreferenceControllerApi - functional programming interface
 * @export
 */
export const SessionPreferenceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionPreferenceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getSessionPreference
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionPreferenceUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionPreferenceUsingGET(claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SessionPreferenceControllerApi - factory interface
 * @export
 */
export const SessionPreferenceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionPreferenceControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getSessionPreference
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionPreferenceUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getSessionPreferenceUsingGET(claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionPreferenceControllerApi - object-oriented interface
 * @export
 * @class SessionPreferenceControllerApi
 * @extends {BaseAPI}
 */
export class SessionPreferenceControllerApi extends BaseAPI {
    /**
     * 
     * @summary getSessionPreference
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionPreferenceControllerApi
     */
    public getSessionPreferenceUsingGET(claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return SessionPreferenceControllerApiFp(this.configuration).getSessionPreferenceUsingGET(claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SicCodeControllerApi - axios parameter creator
 * @export
 */
export const SicCodeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Sic Codes
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSicCodeByCaseNumberUsingGET: async (caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('getSicCodeByCaseNumberUsingGET', 'caseNumber', caseNumber)
            const localVarPath = `/v1/bostools/siccode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (caseNumber !== undefined) {
                localVarQueryParameter['caseNumber'] = caseNumber;
            }

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Sic Code
         * @param {string} groupID groupID
         * @param {string} sicCode sicCode
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSicCodeUsingPUT: async (groupID: string, sicCode: string, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupID' is not null or undefined
            assertParamExists('updateSicCodeUsingPUT', 'groupID', groupID)
            // verify required parameter 'sicCode' is not null or undefined
            assertParamExists('updateSicCodeUsingPUT', 'sicCode', sicCode)
            const localVarPath = `/v1/bostools/siccode/{groupID}`
                .replace(`{${"groupID"}}`, encodeURIComponent(String(groupID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (sicCode !== undefined) {
                localVarQueryParameter['sicCode'] = sicCode;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SicCodeControllerApi - functional programming interface
 * @export
 */
export const SicCodeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SicCodeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Sic Codes
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSicCodeByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GrpERCase>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSicCodeByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Sic Code
         * @param {string} groupID groupID
         * @param {string} sicCode sicCode
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSicCodeUsingPUT(groupID: string, sicCode: string, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSicCodeUsingPUT(groupID, sicCode, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SicCodeControllerApi - factory interface
 * @export
 */
export const SicCodeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SicCodeControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Sic Codes
         * @param {string} caseNumber caseNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSicCodeByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<Array<GrpERCase>> {
            return localVarFp.getSicCodeByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Sic Code
         * @param {string} groupID groupID
         * @param {string} sicCode sicCode
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSicCodeUsingPUT(groupID: string, sicCode: string, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<number> {
            return localVarFp.updateSicCodeUsingPUT(groupID, sicCode, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SicCodeControllerApi - object-oriented interface
 * @export
 * @class SicCodeControllerApi
 * @extends {BaseAPI}
 */
export class SicCodeControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Sic Codes
     * @param {string} caseNumber caseNumber
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SicCodeControllerApi
     */
    public getSicCodeByCaseNumberUsingGET(caseNumber: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return SicCodeControllerApiFp(this.configuration).getSicCodeByCaseNumberUsingGET(caseNumber, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Sic Code
     * @param {string} groupID groupID
     * @param {string} sicCode sicCode
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SicCodeControllerApi
     */
    public updateSicCodeUsingPUT(groupID: string, sicCode: string, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return SicCodeControllerApiFp(this.configuration).updateSicCodeUsingPUT(groupID, sicCode, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SsoLoggingControllerApi - axios parameter creator
 * @export
 */
export const SsoLoggingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Flag is maintenance mode is on or not
         * @param {string} companyName companyName
         * @param {string} incomingRequest incomingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSsoLogEntryUsingPUT: async (companyName: string, incomingRequest: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyName' is not null or undefined
            assertParamExists('saveSsoLogEntryUsingPUT', 'companyName', companyName)
            // verify required parameter 'incomingRequest' is not null or undefined
            assertParamExists('saveSsoLogEntryUsingPUT', 'incomingRequest', incomingRequest)
            const localVarPath = `/v1/sso/{incomingRequest}/log/{companyName}`
                .replace(`{${"companyName"}}`, encodeURIComponent(String(companyName)))
                .replace(`{${"incomingRequest"}}`, encodeURIComponent(String(incomingRequest)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SsoLoggingControllerApi - functional programming interface
 * @export
 */
export const SsoLoggingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SsoLoggingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Flag is maintenance mode is on or not
         * @param {string} companyName companyName
         * @param {string} incomingRequest incomingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSsoLogEntryUsingPUT(companyName: string, incomingRequest: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSsoLogEntryUsingPUT(companyName, incomingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SsoLoggingControllerApi - factory interface
 * @export
 */
export const SsoLoggingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SsoLoggingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Flag is maintenance mode is on or not
         * @param {string} companyName companyName
         * @param {string} incomingRequest incomingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSsoLogEntryUsingPUT(companyName: string, incomingRequest: string, options?: any): AxiosPromise<string> {
            return localVarFp.saveSsoLogEntryUsingPUT(companyName, incomingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SsoLoggingControllerApi - object-oriented interface
 * @export
 * @class SsoLoggingControllerApi
 * @extends {BaseAPI}
 */
export class SsoLoggingControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get Flag is maintenance mode is on or not
     * @param {string} companyName companyName
     * @param {string} incomingRequest incomingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoLoggingControllerApi
     */
    public saveSsoLogEntryUsingPUT(companyName: string, incomingRequest: string, options?: any) {
        return SsoLoggingControllerApiFp(this.configuration).saveSsoLogEntryUsingPUT(companyName, incomingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SwaggerWelcomeApi - axios parameter creator
 * @export
 */
export const SwaggerWelcomeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary openapiYaml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiYamlUsingGET1: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api-docs/swagger-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary redirectToUi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToUiUsingGET: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/swagger-ui.html`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SwaggerWelcomeApi - functional programming interface
 * @export
 */
export const SwaggerWelcomeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SwaggerWelcomeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary openapiYaml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiYamlUsingGET1(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiYamlUsingGET1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary redirectToUi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redirectToUiUsingGET(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redirectToUiUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SwaggerWelcomeApi - factory interface
 * @export
 */
export const SwaggerWelcomeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SwaggerWelcomeApiFp(configuration)
    return {
        /**
         * 
         * @summary openapiYaml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiYamlUsingGET1(options?: any): AxiosPromise<object> {
            return localVarFp.openapiYamlUsingGET1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary redirectToUi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectToUiUsingGET(options?: any): AxiosPromise<string> {
            return localVarFp.redirectToUiUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SwaggerWelcomeApi - object-oriented interface
 * @export
 * @class SwaggerWelcomeApi
 * @extends {BaseAPI}
 */
export class SwaggerWelcomeApi extends BaseAPI {
    /**
     * 
     * @summary openapiYaml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwaggerWelcomeApi
     */
    public openapiYamlUsingGET1(options?: any) {
        return SwaggerWelcomeApiFp(this.configuration).openapiYamlUsingGET1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary redirectToUi
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SwaggerWelcomeApi
     */
    public redirectToUiUsingGET(options?: any) {
        return SwaggerWelcomeApiFp(this.configuration).redirectToUiUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UpdateAgentNumberControllerApi - axios parameter creator
 * @export
 */
export const UpdateAgentNumberControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary UpdateCaseAgentNumber
         * @param {string} caseID caseID
         * @param {CaseAgentNumber} caseAgentNumber caseAgentNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseAgentNumberUsingPUT: async (caseID: string, caseAgentNumber: CaseAgentNumber, claims?: object, headers?: object, tokenValue?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseID' is not null or undefined
            assertParamExists('updateCaseAgentNumberUsingPUT', 'caseID', caseID)
            // verify required parameter 'caseAgentNumber' is not null or undefined
            assertParamExists('updateCaseAgentNumberUsingPUT', 'caseAgentNumber', caseAgentNumber)
            const localVarPath = `/v1/bostools/caseagentnumber/{caseID}`
                .replace(`{${"caseID"}}`, encodeURIComponent(String(caseID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (claims !== undefined) {
                localVarQueryParameter['claims'] = claims;
            }

            if (headers !== undefined) {
                localVarQueryParameter['headers'] = headers;
            }

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseAgentNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UpdateAgentNumberControllerApi - functional programming interface
 * @export
 */
export const UpdateAgentNumberControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UpdateAgentNumberControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary UpdateCaseAgentNumber
         * @param {string} caseID caseID
         * @param {CaseAgentNumber} caseAgentNumber caseAgentNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCaseAgentNumberUsingPUT(caseID: string, caseAgentNumber: CaseAgentNumber, claims?: object, headers?: object, tokenValue?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CaseAgentNumber>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCaseAgentNumberUsingPUT(caseID, caseAgentNumber, claims, headers, tokenValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UpdateAgentNumberControllerApi - factory interface
 * @export
 */
export const UpdateAgentNumberControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UpdateAgentNumberControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary UpdateCaseAgentNumber
         * @param {string} caseID caseID
         * @param {CaseAgentNumber} caseAgentNumber caseAgentNumber
         * @param {object} [claims] 
         * @param {object} [headers] 
         * @param {string} [tokenValue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCaseAgentNumberUsingPUT(caseID: string, caseAgentNumber: CaseAgentNumber, claims?: object, headers?: object, tokenValue?: string, options?: any): AxiosPromise<CaseAgentNumber> {
            return localVarFp.updateCaseAgentNumberUsingPUT(caseID, caseAgentNumber, claims, headers, tokenValue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UpdateAgentNumberControllerApi - object-oriented interface
 * @export
 * @class UpdateAgentNumberControllerApi
 * @extends {BaseAPI}
 */
export class UpdateAgentNumberControllerApi extends BaseAPI {
    /**
     * 
     * @summary UpdateCaseAgentNumber
     * @param {string} caseID caseID
     * @param {CaseAgentNumber} caseAgentNumber caseAgentNumber
     * @param {object} [claims] 
     * @param {object} [headers] 
     * @param {string} [tokenValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateAgentNumberControllerApi
     */
    public updateCaseAgentNumberUsingPUT(caseID: string, caseAgentNumber: CaseAgentNumber, claims?: object, headers?: object, tokenValue?: string, options?: any) {
        return UpdateAgentNumberControllerApiFp(this.configuration).updateCaseAgentNumberUsingPUT(caseID, caseAgentNumber, claims, headers, tokenValue, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebMvcLinksHandlerApi - axios parameter creator
 * @export
 */
export const WebMvcLinksHandlerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linksUsingGET: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebMvcLinksHandlerApi - functional programming interface
 * @export
 */
export const WebMvcLinksHandlerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebMvcLinksHandlerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linksUsingGET(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: Link; }; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linksUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebMvcLinksHandlerApi - factory interface
 * @export
 */
export const WebMvcLinksHandlerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebMvcLinksHandlerApiFp(configuration)
    return {
        /**
         * 
         * @summary links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linksUsingGET(options?: any): AxiosPromise<{ [key: string]: { [key: string]: Link; }; }> {
            return localVarFp.linksUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebMvcLinksHandlerApi - object-oriented interface
 * @export
 * @class WebMvcLinksHandlerApi
 * @extends {BaseAPI}
 */
export class WebMvcLinksHandlerApi extends BaseAPI {
    /**
     * 
     * @summary links
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebMvcLinksHandlerApi
     */
    public linksUsingGET(options?: any) {
        return WebMvcLinksHandlerApiFp(this.configuration).linksUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


